import { ESTRATEGIA_RETRY_PADRAO, FalhaHttp, type ClienteHttp, type RespostaHttp } from '@next/infraestrutura/http'
import type { OpcaoGrupoDeLocaisDeTrabalho } from '../catalogo-grupo-de-locais-de-trabalho.tipos'

const ENDPOINT = '/user-group'
const ehRegistro = (valor: unknown): valor is Record<string, unknown> => typeof valor === 'object' && valor !== null && !Array.isArray(valor)
const selecionarCampos = (valor: Record<string, unknown>, campos: readonly string[]): Record<string, unknown> => Object.fromEntries(campos.filter(campo => campo in valor).map(campo => [campo, valor[campo]]))
const projetar = (valor: Record<string, unknown>): OpcaoGrupoDeLocaisDeTrabalho => {
  const resultado = selecionarCampos(valor, ['id', 'name', 'companies', 'groups'])
  if (Array.isArray(valor.companies)) resultado.companies = valor.companies.map((item: unknown) => ehRegistro(item) ? selecionarCampos(item, ['id', 'name']) : item)
  if (Array.isArray(valor.groups)) resultado.groups = valor.groups.map((item: unknown) => ehRegistro(item) ? selecionarCampos(item, ['id', 'name']) : item)
  return resultado as OpcaoGrupoDeLocaisDeTrabalho
}
const falhaInvalida = (resposta: RespostaHttp<unknown>): FalhaHttp => new FalhaHttp({
  tipo: 'resposta_invalida', servico: 'condominio', metodo: 'GET', endpoint: ENDPOINT,
  status: resposta.status, causa: resposta.data,
  ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
})

export class ListarOpcoesGrupoDeLocaisDeTrabalhoRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}
  executar = async (sinal: AbortSignal): Promise<readonly OpcaoGrupoDeLocaisDeTrabalho[]> => {
    const resposta = await this.http.get<unknown>(ENDPOINT, { parametros: { order_by: 'name' }, signal: sinal, retry: ESTRATEGIA_RETRY_PADRAO })
    if (resposta.status === 204 || (ehRegistro(resposta.data) && 'no-data' in resposta.data)) return []
    if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) throw falhaInvalida(resposta)
    return resposta.data.success.filter(ehRegistro).map(projetar)
  }
}
